<template>
    <button
        :id="buttonId"
        class="tl-text-copiable"
        :class="{ 'tl-text-copiable-copied': copied }"
        type="button"
        @click="copy"
    >
        <span
            class="tl-text-copiable-content"
            :style="`text-align: ${alignment}`"
        >
            {{ content }}
        </span>
        <i
            class="mi-copy"
            @click="copy"
        />
    </button>
</template>

<script setup lang="ts">
import { computed, ref, useId } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    content: string
    options?: {
        alignment?: string
    }
}>()

const buttonId = computed(() => {
    return props.id || useId()
})

const alignment = computed(() => props.options?.alignment || '')

const copied = ref(false)

const copy = async () => {
    try {
        if (copied.value) return

        await navigator.clipboard.writeText(props.content)
        copied.value = true
        setTimeout(() => {
            copied.value = false
        }, 3000)
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to copy text:', err)
    }
}

</script>

<style lang="sass" scoped>
@import "./TextCopiable.sass"
</style>
